// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JUr7","index":"styles_index__sEsoc"};